export default __webpack_public_path__ + "static/media/hotDinner.62f9c823.JPG";